<template>
  <div>
    <NavClient />
    <div class="register-new">
      <div id="content">
        <div class="register">
          <div class="wrapper">
            <div class="inner">
              <div class="main">
                <h1 class="main-title">Job Request Form</h1>
                <sui-form autocomplete="off" class="ui form">
                  <p class="required-text">
                    <span>*</span>Required information
                  </p>
                  <div class="list">
                    <sui-form-field required>
                      <label>Name</label>
                      <div class="two-fields">
                        <sui-form-field>
                          <input
                            type="text"
                            name="shipping[first-name]"
                            placeholder="First Name"
                          />
                        </sui-form-field>
                        <sui-form-field>
                          <input
                            type="text"
                            name="shipping[last-name]"
                            placeholder="Last Name"
                          />
                        </sui-form-field>
                      </div>
                    </sui-form-field>
                    <sui-form-field required>
                      <label>Company Name</label>
                      <input
                        type="text"
                        name="company"
                        placeholder="Enter your company name"
                      />
                    </sui-form-field>
                    <sui-form-field required>
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                      />
                    </sui-form-field>
                    <sui-form-field>
                      <label>Phone No.</label>
                      <input
                        type="text"
                        name="phone"
                        placeholder="Enter your phone number"
                      />
                    </sui-form-field>
                    <sui-form-field>
                      <label>Address</label>
                      <input
                        type="text"
                        name="phone"
                        placeholder="Enter your address"
                      />
                    </sui-form-field>
                    <sui-form-field required>
                      <label>Message to Us</label>
                      <textarea
                        rows="4"
                        placeholder="Leave us message .."
                      ></textarea>
                    </sui-form-field>
                    <div class="submit-button">
                      <button class="btn btn-blue" type="submit">Submit</button>
                    </div>
                  </div>
                </sui-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import NavClient from "@/components/layouts/NavClient";
import Footer from "@/components/layouts/Footer";
export default {
  name: "RegisterNew",
  components: {
    NavClient,
    Footer,
  },
  data() {
    return {
      current: null,
      options: [
        {
          text: "0-1 Year",
          value: 1,
        },
        {
          text: "2-5 Years",
          value: 2,
        },
        {
          text: "Over 5 Years",
          value: 3,
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
@import "~@/assets/stylesheets/register";
.register-new {
  h3 {
    color: $black;
    font-size: 1.2em;
    margin-bottom: 1.5rem;
  }
  label {
    /* stylelint-disable-next-line declaration-no-important */
    color: #999 !important;
  }
  .flex-row {
    align-items: center;
    display: flex;
    justify-content: space-between;
    .ui.selection.dropdown {
      /* stylelint-disable-next-line declaration-no-important */
      min-width: auto !important;
      width: 30%;
    }
  }

  .range-slider {
    margin-bottom: 1rem;
    width: 80%;
    .text {
      color: $black;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 0.5rem;
    }
    .slider-area {
      padding-top: 1.5rem;
      width: 100%;
    }
  }
  .submit-button {
    .btn {
      width: auto;
    }
  }
}
@media only screen and (max-width: 991px) {
  .register-new {
    .range-slider {
      width: 100%;
    }
  }
}
</style>
